import React, { useEffect, useRef, useState } from "react";
import { apiGet, mediaUrl } from "../lib/api";

const FALLBACK_SRC = "https://customer-assets-lqy194kg.emergentagent.net/job_rap-anime-immerse/artifacts/v7yzg3lz_michael-jackson-billie-jean-live-1983-ytmp4.savetube.vip.mp4";

// Muted, looping full-screen background video (self-hosted). Admin can replace
// it via /admin (stored in settings.bg_video); falls back to the default clip.
export default function YouTubeBackground() {
  const videoRef = useRef(null);
  const [src, setSrc] = useState(FALLBACK_SRC);

  useEffect(() => {
    apiGet("/settings")
      .then((d) => { if (d && d.bg_video) setSrc(mediaUrl(d.bg_video)); })
      .catch(() => {});
  }, []);

  useEffect(() => {
    const v = videoRef.current;
    if (!v) return;
    v.muted = true;
    const p = v.play();
    if (p && p.catch) p.catch(() => {});
  }, [src]);

  return (
    <div className="fixed inset-0 z-0 overflow-hidden" aria-hidden data-testid="yt-bg">
      <video
        ref={videoRef}
        key={src}
        src={src}
        autoPlay
        muted
        loop
        playsInline
        preload="auto"
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 min-w-full min-h-full w-auto h-auto object-cover"
        style={{ width: "100vw", height: "100vh" }}
      />
      <div className="absolute inset-0" style={{ background: "rgba(236,231,219,0.58)" }} />
    </div>
  );
}
